import React, { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import useLocale from "../../../hooks/useLocale";
import { fetchSingleSailorHistory } from "../../../services/sailorService";
import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../../components/GovGrMaterialTable";
import { useQuery } from "react-query";
import GovGrModal from "../../../components/GovGrModal";
import GovGrButton from "../../../components/GovGrButton";

function ViewDialog({ open, close, selectedItem }) {
  const { t } = useLocale();
  const [error, setError] = useState("");

  const { data, isError, isLoading } = useQuery(
    ["sailorHistory", selectedItem?.s_id],
    () => fetchSingleSailorHistory(selectedItem?.s_id),
    {
      enabled: Object.keys(selectedItem).length !== 0,
    }
  );

  return (
    <>
      <GovGrModal open={open} onClose={close} customContent={true}>
        <DialogTitle id="form-dialog-title">{t("Sailor History")}</DialogTitle>
        <CustomAlert
          open={!!error}
          close={() => {
            setError("");
          }}
          message={t("A network error occured, please try again later")}
        />

        <DialogContent>
          {/* <div className={classes.table}> */}
          <CustomTable
            isLoading={isLoading}
            columns={[
              {
                title: t("Ship Name"),
                field: "sh_dds",
              },
              {
                title: t("Sailor Specialization"),
                field: "sp_name",
              },
              {
                title: t("From date"),
                field: "sr_start_dt",
              },
              {
                title: t("To date"),
                field: "sr_leave_dt",
              },
            ]}
            data={data}
          />
          {/* </div> */}
        </DialogContent>
        <DialogActions>
          <GovGrButton
            onClick={close}
            color="primary"
            buttonText={t("Close")}
          />
        </DialogActions>
      </GovGrModal>
    </>
  );
}

export default ViewDialog;
